<template>
  <div>
    <Card shadow>
      <Row :gutter="16">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">风控类型:</span>
            <Select
              placeholder="风控类型"
              v-model="table.params.ctype"
              clearable
              filterable
              @on-change="SearList"
            >
              <Option
                v-for="item in select.ctype_list"
                :value="item.value"
                :key="item.value"
                :label="item.name"
              >
                {{ item.name }}
                <span style="color: #bbb"></span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">标签:</span>
            <Select
              placeholder="标签"
              v-model="table.params.tag"
              clearable
              filterable
              @on-change="SearList"
            >
              <Option
                v-for="item in select.smart_tag_list"
                :value="item.value"
                :key="item.value"
                :label="item.name"
              >
                {{ item.name }}
                <span style="color: #bbb">（{{ item.value }}）</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="3">
          <Button type="primary" @click="SearList" icon="md-refresh"
            >刷新</Button
          >
        </Col>
        <Button
          type="info"
          :size="isMOble() ? 'small' : 'default'"
          @click="Refres"
          style="float: right"
          >同步配置</Button
        >
        <Button
          type="primary"
          @click="OpenModal2('add')"
          style="float: right; margin-right: 5px"
          :size="isMOble() ? 'small' : 'default'"
          >添加配置</Button
        >
        <!-- <Button type="primary" @click="Refres()" style="float: right; margin-right:5px;">刷新配置</Button> -->
        <Button
          type="primary"
          @click="openModalByIndex(6)"
          style="float: right; margin-right: 5px"
          :size="isMOble() ? 'small' : 'default'"
          >黑名单</Button
        >
        <Button
          type="primary"
          @click="openModalByIndex(3)"
          style="float: right; margin-right: 5px"
          :size="isMOble() ? 'small' : 'default'"
          >白名单</Button
        >
        <Button
          type="primary"
          @click="openModalByIndex(5)"
          style="float: right; margin-right: 5px"
          :size="isMOble() ? 'small' : 'default'"
          >查询玩家限制信息</Button
        >
      </Row>
    </Card>
    <Table
      :ref="table.ref"
      :columns="table.columns"
      :data="table.data"
      :max-height="tableMaxHeight"
      border
      style="margin-top: 12px"
      @on-selection-change="SelectRow"
      @on-sort-change="changeSort"
    />
    <Page
      show-total
      show-sizer
      style="margin-top: 12px"
      :page-size="table.params.page_size"
      :total="table.page_total"
      :current="table.page_current"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />
    <!-- 控制策略 -->
    <Modal
      v-model="modal1.show"
      @on-cancel="closeModalByIndex(1)"
      :width="isMOble() ? '600' : '900'"
      id="modal1"
      class-name="vertical-center-modal"
      class="intelligentModal1"
    >
      <div slot="header">新增控制策略</div>
      <Form
        :ref="modal1.form.ref"
        :model="modal1.form.data"
        :rules="modal1.form.rules"
        label-position="top"
        style="max-height: 750px; overflow-y: scroll; overflow-x: hidden"
      >
        <FormItem prop="fields">
          <CheckboxGroup v-model="modal1.form.data.fields">
            <Collapse v-model="modal1.list_show">
              <Panel
                v-for="(item, index) in modal1.list"
                :name="`${index + 1}`"
                :key="index"
                v-show="!item.disable"
              >
                {{ item.title }}
                <div slot="content">
                  <Row>
                    <div
                      style="width: 20%; display: inline-block"
                      class="diyItemCol"
                      v-for="(item2, index2) in item.list"
                      :key="index2"
                    >
                      <Checkbox :label="item2.key">{{ item2.name }}</Checkbox>
                    </div>
                    <!-- <Col span="4" class="diyItemCol" v-for="(item2, index2) in item.list" :key="index2">
                                            <Checkbox :label="item2.key">{{ item2.name }}</Checkbox>
                                        </Col> -->
                  </Row>
                </div>
              </Panel>
            </Collapse>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="Update">下一步</Button>
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="modal2.show"
      :width="isMOble() ? '620px' : '50%'"
      class="mobileW"
      class-name="vertical-center-modal"
      id="modal2"
    >
      <div slot="header">编辑风控配置</div>

      <Form
        :ref="modal2.form.ref"
        :model="modal2.form.data"
        :label-width="130"
        style="max-height: 750px; overflow-y: scroll; overflow-x: hidden"
      >
        <Card dis-hover>
          <Row style="padding-bottom: 10px">
            <Col>
              <Button type="default">基础信息配置</Button>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="风控类型">
                <Select placeholder="风控类型" v-model="modal2.form.data.ctype">
                  <Option
                    v-for="item in select.ctype_list"
                    :value="item.value"
                    :key="item.value"
                    :label="item.name"
                  >
                    {{ item.name }}
                    <span style="color: #bbb"></span>
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="风控名称">
                <Input type="text" v-model="modal2.form.data.name" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="非捕鱼类最大执行次数(天)">
                <Input type="text" v-model="modal2.form.data.succ_max" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="捕鱼类最大执行次数(天)">
                <Input type="text" v-model="modal2.form.data.fish_succ_max" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="风控标签">
                <Select placeholder="风控标签" v-model="modal2.form.data.tag">
                  <Option
                    v-for="(item, index) in select.smart_tag_list"
                    :value="item.value"
                    :key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="策略排序">
                <InputNumber
                  v-model="modal2.form.data.sorts"
                  style="width: 100%"
                  :min="0"
                />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="策略状态">
                <RadioGroup v-model="modal2.form.data.status">
                  <Radio label="0">禁用</Radio>
                  <Radio label="1">启用</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="描述">
                <Input type="text" v-model="modal2.form.data.reason" />
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Card dis-hover style="margin-top: 12px">
          <Row style="padding-bottom: 10px">
            <Col>
              <Button type="default">{{
                modal2.form.data.ctype == 0 ? '执行策略配置' : '风控策略配置'
              }}</Button>
            </Col>
          </Row>
          <Row
            :gutter="24"
            v-for="(item, itemindex1) in modal2.form.data.list"
            :key="itemindex1"
          >
            <div
              v-if="
                [50, 77, 78, 87, 88, 90, 82, 101, 104, 111].includes(
                  Number(item.num)
                )
              "
            >
              <FormItem :label="item.name" v-if="item.num == 50">
                <Col span="15">
                  <Select multiple placeholder="游戏信息" v-model="item.val">
                    <Option
                      v-for="(item, index) in select.room_list"
                      :value="`${item.game_id}_${item.level}`"
                      :key="index"
                      :label="`${item.Gname} - ${item.name} - ${item.level}`"
                      >{{ item.Gname }} - {{ item.name }} -
                      {{ item.level }}</Option
                    >
                  </Select>
                </Col>
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="0">所选游戏内</Option>
                    <Option :value="2">所选游戏外</Option>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
              <FormItem
                :label="item.name"
                v-if="
                  item.num == 77 ||
                    item.num == 90 ||
                    item.num == 101 ||
                    item.num == 104
                "
              >
                <Col span="15">
                  <Input type="text" v-model="item.val" />
                </Col>
                <Col span="6">
                  <span style="color: red; font-size: 12px"
                    >多个请用逗号隔开</span
                  >
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
              <FormItem
                :label="item.name"
                v-if="item.num == 87 || item.num == 88 || item.num == 111"
              >
                <Col span="9">
                  <Input type="text" v-model="item.val" />
                </Col>
                <Col span="6">
                  <span style="color: red; font-size: 12px"
                    >多个请用逗号隔开</span
                  >
                </Col>
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="0">所选标签内</Option>
                    <Option :value="2">所选标签外</Option>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
              <FormItem :label="item.name" v-if="item.num == 78">
                <Col span="15">
                  <Select
                    v-model="item.val"
                    filterable
                    multiple
                    placeholder="用户标签"
                    clearable
                  >
                    <Option
                      v-for="(item, index) in select.TagList"
                      :value="`${item.user_tag}`"
                      :label="item.name"
                      :key="index"
                    >
                      {{ item.name
                      }}<span style="color: #bbb">({{ item.user_tag }})</span>
                    </Option>
                  </Select>
                  <!-- <Select multiple placeholder="用户标签" v-model="item.val">
                                        <Option
                                            v-for="(item, index) in select.user_List"
                                            :value="`${index}`"
                                            :key="index"
                                            :label="index"
                                        ></Option>
                                    </Select> -->
                </Col>
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="0">所选标签内</Option>
                    <Option :value="2">所选标签外</Option>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
              <FormItem label="风控属性" v-if="item.num == 82">
                <Col span="15">
                  <Select multiple placeholder="风控属性" v-model="item.val">
                    <Option
                      v-for="item in select.attrs_list"
                      :value="item.value"
                      :key="item.value"
                      :label="item.name"
                    >
                      {{ item.name }}
                      <span style="color: #bbb"></span>
                    </Option>
                  </Select>
                </Col>
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="0">所选标签内</Option>
                    <Option :value="2">所选标签外</Option>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
            </div>
            <div v-else-if="![108, 109, 110, 17].includes(Number(item.num))">
              <FormItem :label="item.name">
                <Col span="6">
                  <InputNumber style="width: 100%" v-model="item.min" />
                </Col>
                <Col span="1" style="text-align: left; padding: 0">{{
                  item.unit || ' '
                }}</Col>
                <Col span="1" style="text-align: center">-</Col>
                <Col span="6">
                  <InputNumber style="width: 100%" v-model="item.max" />
                </Col>
                <Col span="1" style="text-align: left; padding: 0">{{
                  item.unit || ' '
                }}</Col>
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="0">区间</Option>
                    <Option :value="1">小于等于最大值</Option>
                    <Option :value="2">大于等于最大值</Option>
                    <Option :value="3">小于区间随机</Option>
                    <Option :value="4">大于区间随机</Option>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
            </div>
<!--            <div v-else>-->
            <div v-else-if="![17].includes(Number(item.num))">
              <FormItem :label="item.name">
                <Col span="6">
                  <Select placeholder="取值规则" v-model="item.t">
                    <Option :value="1">{{
                      item.num == '110' ? '未绑定' : '不包含'
                    }}</Option>
                    <Option :value="2">{{
                      item.num == '110' ? '已绑定' : '包含'
                    }}</Option
                    >>
                  </Select>
                </Col>
                <Col span="2">
                  <Button type="error" @click="DeleteCelue(itemindex1)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
            </div>
          </Row>
          <Row style="padding-top: 10px; text-align: center">
            <Col>
              <Button type="primary" @click="Back">新增风控策略</Button>
            </Col>
          </Row>
        </Card>

        <Card
          dis-hover
          style="margin-top: 12px"
          v-if="modal2.form.data.ctype == 0"
        >
          <Row style="padding-bottom: 10px">
            <Col>
              <Button type="default">风控数值配置</Button>
            </Col>
          </Row>
          <Row v-for="(item, index) in modal2.form.data.ret" :key="index">
            <FormItem label="策略执行结果">
              <Col span="8" style="margin-right: 10px">
                <Select
                  placeholder="风控名称"
                  v-model="modal2.form.data.ret[index].level"
                  clearable
                  filterable
                >
                  <Option
                    v-for="item in select.ret_List"
                    :value="item.level"
                    :key="item.level"
                    :label="item.name"
                  >
                    {{ item.name }}
                    <span style="color: #bbb">（{{ item.level }}）</span>
                  </Option>
                </Select>
              </Col>
              <Col span="8" style="margin-right: 10px">
                <InputNumber
                  :min="0"
                  :max="100"
                  v-model="modal2.form.data.ret[index].rate"
                  style="width: 100%"
                />
              </Col>
              <Col span="2">%</Col>
              <Col span="3">
                <Button type="error" @click="delete_risk_ret(index)"
                  >删除</Button
                >
              </Col>
            </FormItem>
          </Row>
          <Row style="padding-top: 10px; text-align: center">
            <Col>
              <Button type="primary" @click="addRet"
                >新增策略执行结果配置</Button
              >
            </Col>
          </Row>
        </Card>
        <Card
          dis-hover
          style="margin-top: 12px"
          v-if="modal2.form.data.ctype == 1"
        >
          <Row style="padding-bottom: 10px">
            <Col>
              <Button type="default">风控数值配置</Button>
            </Col>
          </Row>
          <Row
            v-for="(item, itemindex2) in modal2.form.data.risk_user_attr"
            :key="itemindex2"
          >
            <FormItem
              :label="
                (itemindex2 == 0 && '触发当前属性') ||
                  (itemindex2 == 1 && '转为正常属性') ||
                  (itemindex2 == 2 && '跳过概率')
              "
              v-if="itemindex2 < 3"
            >
              <Col span="8" style="margin-right: 10px">
                <Input
                  v-model="modal2.form.data.risk_user_attr[itemindex2].attr"
                  style="width: 100%"
                  :disabled="itemindex2 == 1 || itemindex2 == 2"
                />
              </Col>
              <Col span="8" style="margin-right: 10px">
                <InputNumber
                  :min="0"
                  :max="100"
                  v-model="modal2.form.data.risk_user_attr[itemindex2].rate"
                  style="width: 100%"
                  @on-change="changeAtrNum"
                  :disabled="itemindex2 == 2"
                />
              </Col>
              <Col span="5">%</Col>
            </FormItem>
            <FormItem label="风控属性" v-else>
              <Col span="8" style="margin-right: 10px">
                <AutoComplete
                  v-model="modal2.form.data.risk_user_attr[itemindex2].attr"
                  placeholder="风控属性"
                  filterable
                  allow-create
                  clearable
                >
                  <Option
                    v-for="item in select.attrs_list"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.name }}</Option
                  >
                </AutoComplete>
              </Col>
              <Col span="8" style="margin-right: 10px">
                <InputNumber
                  :min="0"
                  :max="100"
                  v-model="modal2.form.data.risk_user_attr[itemindex2].rate"
                  style="width: 100%"
                  @on-change="changeAtrNum"
                />
              </Col>
              <Col span="2">%</Col>
              <Col span="3">
                <Button type="error" @click="delete_risk_user_attr(itemindex2)"
                  >删除</Button
                >
              </Col>
            </FormItem>
          </Row>

          <Row style="padding-top: 10px; text-align: center">
            <Col>
              <Button type="primary" @click="add">新增属性配置</Button>
            </Col>
          </Row>
        </Card>
        <Card
          dis-hover
          style="margin-top: 12px"
          v-if="modal2.form.data.ctype == 1"
        >
          <Row style="padding-bottom: 10px">
            <Col>
              <Button type="default">清除风控属性</Button>
            </Col>
          </Row>

          <Row>
            <FormItem label="清除风控属性">
              <Col span="8" style="margin-right: 10px">
                <Select
                  placeholder="类型"
                  v-model="modal2.form.data.clean_buff[0].k"
                >
                  <Option
                    v-for="item in select.clean_buff_list"
                    :value="item.value"
                    :key="item.value"
                    :label="item.name"
                  >
                    {{ item.name }}
                    <span style="color: #bbb"></span>
                  </Option>
                </Select>
              </Col>
              <Col span="8" style="margin-right: 10px">
                <InputNumber
                  :min="0"
                  v-model="modal2.form.data.clean_buff[0].v"
                  style="width: 100%"
                />
              </Col>
              <Col span="2">
                <span v-if="modal2.form.data.clean_buff[0].k == 1">次</span>
                <span v-if="modal2.form.data.clean_buff[0].k == 2">分钟</span>
                <span v-if="modal2.form.data.clean_buff[0].k == 3">天</span>
              </Col>
            </FormItem>
          </Row>
        </Card>
      </Form>

      <div slot="footer">
        <!-- <Button type="primary" @click="Back" v-if="modal2.type == 'add'">上一步</Button> -->
        <Button type="primary" @click="Update2">提交</Button>
      </div>
    </Modal>
    <!-- 白名单 -->
    <Modal v-model="modal3.show" :width="isMOble() ? '600' : '850px'">
      <div slot="header">玩家白名单</div>
      <Form
        :ref="modal3.form.ref"
        :model="modal3.params"
        :rules="modal3.form.rules"
        label-position="top"
      >
        <Row :gutter="20">
          <Col span="5">
            <FormItem prop="platid">
              <Select
                v-model="modal3.params.platid"
                filterable
                placeholder="选择APP分组"
                clearable
              >
                <Option
                  v-for="(item, index) in plat_list"
                  :value="item.id"
                  :label="item.name"
                  :key="index"
                >
                  {{ item.name
                  }}<span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem prop="app_id">
              <Select
                placeholder="请选择APP"
                v-model="modal3.params.app_id"
                clearable
                filterable
              >
                <Option
                  v-for="item in select.whiteapp_list.filter(
                    item => item.platform == modal3.params.platid
                  )"
                  :value="item.value"
                  :key="item.value"
                  :label="item.name"
                >
                  {{ item.name
                  }}<span style="color: #bbb">（{{ item.value }}）</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="3">
            <FormItem>
              <Button
                type="primary"
                @click="getGameRiskWhites()"
                :disabled="
                  modal3.params.platid < 0 ||
                    modal3.params.app_id < 0 ||
                    modal3.params.app_id == 'underfind' ||
                    modal3.params.platid == 'underfind'
                "
                icon="md-refresh"
                >查询</Button
              >
            </FormItem>
          </Col>

          <Col span="3">
            <FormItem>
              <Button
                type="primary"
                @click="openModalByIndex(4)"
                :disabled="
                  modal3.params.platid < 0 ||
                    modal3.params.app_id < 0 ||
                    modal3.params.app_id == 'underfind' ||
                    modal3.params.platid == 'underfind'
                "
                >添加白名单</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table
        border
        :columns="modal3.columns"
        :data="modal3.data"
        style="margin-top: 12px"
      />
      <Page
        v-show="modal3.data.length"
        show-sizer
        show-total
        style="margin-top: 10px"
        :total="modal3.total"
        :current="modal3.params.page"
        :page-size-opts="table.pageSizes"
        :page-size="modal3.params.page_size"
        @on-page-size-change="modal3limitchange"
        @on-change="modal3pagechange"
      ></Page>
    </Modal>
    <!-- 添加白名单 -->
    <Modal v-model="modal4.show" @on-cancel="closeModalByIndex(4)" width="650">
      <div slot="header">添加白名单</div>
      <Form
        :ref="modal4.form.ref"
        :model="modal4.params"
        :rules="modal4.form.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="用户ID" prop="uid">
              <InputNumber
                type="text"
                v-model="modal4.params.uid"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="白名单类型">
              <RadioGroup v-model="modal4.params.type">
                <Radio :label="0">不执行智能风控</Radio>
                <Radio :label="1">不执行IP限制</Radio>
                <Radio :label="2">不执行Mac限制</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateGameRiskWhite">提交</Button>
      </div>
    </Modal>
    <!-- 黑名单 -->
    <Modal v-model="modal6.show" :width="isMOble() ? '600' : '850px'">
      <div slot="header">玩家黑名单</div>
      <Form
        :ref="modal6.form.ref"
        :model="modal6.params"
        :rules="modal6.form.rules"
        label-position="top"
      >
        <Row :gutter="20">
          <Col span="5">
            <FormItem prop="platid">
              <Select
                v-model="modal6.params.platid"
                filterable
                placeholder="选择APP分组"
                clearable
              >
                <Option
                  v-for="(item, index) in plat_list"
                  :value="item.id"
                  :label="item.name"
                  :key="index"
                >
                  {{ item.name
                  }}<span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem prop="app_id">
              <Select
                placeholder="请选择APP"
                v-model="modal6.params.app_id"
                clearable
                filterable
              >
                <Option
                  v-for="item in select.whiteapp_list.filter(
                    item => item.platform == modal6.params.platid
                  )"
                  :value="item.value"
                  :key="item.value"
                  :label="item.name"
                >
                  {{ item.name
                  }}<span style="color: #bbb">（{{ item.value }}）</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="3">
            <FormItem>
              <Button
                type="primary"
                @click="getGameRiskBlackIps"
                :disabled="
                  modal6.params.platid < 0 ||
                    modal6.params.app_id < 0 ||
                    modal6.params.app_id == 'underfind' ||
                    modal6.params.platid == 'underfind'
                "
                icon="md-refresh"
                >查询</Button
              >
            </FormItem>
          </Col>
          <Col span="3">
            <FormItem>
              <Button
                type="primary"
                @click="openModalByIndex(7)"
                :disabled="
                  modal6.params.platid < 0 ||
                    modal6.params.app_id < 0 ||
                    modal6.params.app_id == 'underfind' ||
                    modal6.params.platid == 'underfind'
                "
                >添加黑名单</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table
        border
        :columns="modal6.columns"
        :data="modal6.data"
        style="margin-top: 12px"
      />
    </Modal>
    <!-- 添加黑名单 -->
    <Modal v-model="modal7.show" @on-cancel="closeModalByIndex(7)" width="650">
      <div slot="header">玩家黑名单</div>
      <Form :model="modal7.params" :label-width="120">
        <Row>
          <Col span="20">
            <FormItem label="IP地址">
              <Input
                type="text"
                v-model="modal7.params.ip"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="描述信息">
              <Input
                type="textarea"
                v-model="modal7.params.desc"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateGameRiskBlackIp()">提交</Button>
      </div>
    </Modal>
    <!-- 查询玩家限制信息 -->
    <Modal v-model="modal5.show" :width="isMOble() ? '600' : '800px'">
      <div slot="header">查询玩家限制信息</div>
      <Form
        :ref="modal5.form.ref"
        :model="modal5.params"
        :rules="modal5.form.rules"
        label-position="top"
      >
        <Row :gutter="20">
          <Col span="5">
            <FormItem prop="platid">
              <Select
                v-model="modal5.params.platid"
                filterable
                placeholder="选择APP分组"
                clearable
              >
                <Option
                  v-for="(item, index) in plat_list"
                  :value="item.id"
                  :label="item.name"
                  :key="index"
                >
                  {{ item.name
                  }}<span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem prop="app_id">
              <Select
                placeholder="请选择APP"
                v-model="modal5.params.app_id"
                clearable
                filterable
              >
                <Option
                  v-for="item in select.whiteapp_list.filter(
                    item => item.platform == modal5.params.platid
                  )"
                  :value="item.value"
                  :key="item.value"
                  :label="item.name"
                >
                  {{ item.name
                  }}<span style="color: #bbb">（{{ item.value }}）</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem prop="t">
              <Select
                placeholder="查询类型"
                v-model="modal5.params.t"
                clearable
                filterable
              >
                <Option
                  v-for="item in modal5.type_list"
                  :value="item.value"
                  :key="item.value"
                  :label="item.name"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem prop="uid">
              <InputNumber
                placeholder="用户ID"
                type="text"
                v-model="modal5.params.uid"
                style="width: 100%"
              />
            </FormItem>
          </Col>
          <Col span="3">
            <FormItem>
              <Button type="primary" @click="searchSmartList" icon="md-refresh"
                >查询</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div>
        <Card v-if="modal5.total" :bordered="false">
          <p slot="title">总共{{ modal5.total }}个</p>
          <p>{{ modal5.data }}</p>
        </Card>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  GetGameRoomInfo,
  GetAppTagList,
  GetSmartRiskList,
  UpdateSmartRiskList,
  DelSmartRiskList,
  RefreshConfig,
  GetGameRiskWhites,
  UpdateGameRiskWhite,
  QuerySmartRiskInfo,
  GetGameRiskBlackIps,
  GetSmartRiskAttrs,
  UserRiskBuffList,
  TransTopReq
} from '@/api/admin/risk'
import { GetUserTagList } from '@/api/admin/player'
export default {
  name: 'intelligentLibConf',
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        app_list: [],
        ctype_list: [
          { value: 0, name: '执行风控策略' },
          { value: 1, name: '玩家风控属性' }
        ],
        clean_buff_list: [
          { value: 1, name: '转入' },
          { value: 2, name: '有效期' },
          { value: 3, name: '自然日' }
        ],
        whiteapp_list: [],
        room_list: [],
        smart_tag_list: [],
        attrs_list: [],
        ret_List: [],
        TagList: [],
        user_List: new Array(21)
      },
      table: {
        ref: 'table',
        params: {
          ctype: -1,
          page: 1,
          page_size: 10,
          sort: 0
        },
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          // { type: 'selection', title: 'ID', key: 'id', fixed: 'left', width: 50 },
          { title: '编号', key: 'id', width: 90, align: 'center' },
          {
            title: '风控类型',
            width: 180,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              return h(
                'div',
                {
                  style: `color:${['blue', '#19be6b'][params.row.ctype]}`
                },
                ['执行风控策略', '玩家风控属性'][params.row.ctype]
              )
            }
          },
          {
            title: '标签',
            key: 'tag',
            width: 180,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              let arr = []
              let app_info = this.select.smart_tag_list.filter(
                v => v.value == params.row.tag
              )[0]

              if (app_info) {
                arr.push(
                  h('span', app_info.name),
                  h('span', { style: 'color:#bbb' }, `（${app_info.value}）`)
                )
              }

              return h('div', arr)
            }
          },
          {
            title: '名称',
            key: 'name',
            width: 180,
            resizable: true,
            align: 'center'
          },
          {
            title: '描述',
            key: 'reason',
            width: 180,
            resizable: true,
            align: 'center'
          },
          {
            title: '最大执行次数',
            key: 'succ_max',
            width: 180,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              let arr = []
              arr.push(
                h('p', [
                  h('span', '非捕鱼类'),
                  h(
                    'span',
                    { style: 'color:#ed4014;' },
                    `  (${params.row.succ_max})`
                  )
                ]),
                h('p', [
                  h('span', '捕鱼类'),
                  h(
                    'span',
                    { style: 'color:#ed4014;' },
                    `  (${params.row.fish_succ_max})`
                  )
                ])
              )

              return h('div', arr)
              // return h("div",
              //     {style: `color:${["#ed4014", "#19be6b"][params.row.status]}`},["关闭", "开启"][params.row.status]
              // );
            }
          },
          {
            title: '排序',
            key: 'sorts',
            width: 180,
            resizable: true,
            align: 'center',
            sortable: true,
            sortMethod: function(a, b, type) {}
          },
          {
            title: '状态',
            width: 180,
            resizable: true,
            align: 'center',
            render: (h, params) =>
              h(
                'div',
                { style: `color:${['#ed4014', '#19be6b'][params.row.status]}` },
                ['关闭', '开启'][params.row.status]
              ),
            filters: [
              { value: 0, label: '关闭' },
              { value: 1, label: '开启' }
            ],
            filterMultiple: false,
            filterMethod(value, row) {
              return row.status == value
            }
          },
          {
            title: '最后修改时间',
            key: 'updated_time',
            width: 180,
            resizable: true,
            align: 'center',
            sortable: true,
            sortMethod: function(a, b, type) {}
          },
          {
            fixed: this.isMOble() ? '' : 'right',
            title: '操作',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      disabled: params.row.not_edit
                    },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.OpenModal2('edit', params.row)
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      disabled: params.row.not_edit
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          onOk: () => {
                            this.Delete(params.row.id)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        data: [],
        page_total: 1,
        page_current: 1
      },
      modal1: {
        show: false,
        type: 'add',
        list: [
          {
            title: '输赢天数',
            list: [
              {
                num: 102,
                key: 'type_continue_win',
                name: '连赢天数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 103,
                key: 'type_continue_lose',
                name: '连输天数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 114,
                key: 'type_continue_win_board',
                name: '连赢局数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 115,
                key: 'type_continue_lose_board',
                name: '连输局数',
                inp_type: '',
                save_type: '',
                unit: ''
              }
            ]
          },
          {
            title: '注册活跃',
            list: [
              {
                num: 1,
                key: 'register_time',
                name: '注册天数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 2,
                key: 'login_num',
                name: '累计登陆次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 3,
                key: 'login_three_num',
                name: '3天登陆次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 4,
                key: 'login_seven_num',
                name: '7天登陆次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 5,
                key: 'login_thrity_num',
                name: '30天登陆次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 6,
                key: 'unlogin_day',
                name: '未登录天数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 84,
                key: 'type_three_login_day',
                name: '3天登陆天数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 85,
                key: 'type_seven_login_day',
                name: '7天登陆天数',
                inp_type: '',
                save_type: '',
                unit: ''
              }
            ]
          },
          {
            title: '投注金额',
            list: [
              {
                num: 7,
                key: 'all_bet',
                name: '历史投注',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 8,
                key: 'today_bet',
                name: '当天投注',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 9,
                key: 'three_bet',
                name: '最近3天投注',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 10,
                key: 'seven_bet',
                name: '最近7天投注',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 11,
                key: 'thrity_bet',
                name: '最近30天投注',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              // {
              //   num: 60,
              //   key: 'after_bet',
              //   name: '转入后投注',
              //   inp_type: '',
              //   save_type: 'X10000',
              //   unit: '元'
              // },
              // {
              //   num: 105,
              //   key: 'type_unpay_bet_point',
              //   name: '未转入投注金额',
              //   inp_type: '',
              //   save_type: 'X10000',
              //   unit: '元'
              // }
            ]
          },
          {
            title: '返奖金额',
            list: [
              {
                num: 12,
                key: 'all_hit',
                name: '历史返奖',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 13,
                key: 'today_hit',
                name: '当天返奖',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 14,
                key: 'three_hit',
                name: '最近3天返奖',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 15,
                key: 'seven_hit',
                name: '最近7天返奖',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 16,
                key: 'thrity_hit',
                name: '最近30天返奖',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              // {
              //   num: 68,
              //   key: 'after_bet_hit',
              //   name: '转入后返奖',
              //   inp_type: '',
              //   save_type: 'X10000',
              //   unit: '元'
              // }
            ]
          },
          {
            title: '投注次数',
            list: [
              {
                num: 54,
                key: 'all_bet_num',
                name: '历史投注次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 55,
                key: 'today_bet_num',
                name: '当天投注次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 56,
                key: 'three_bet_num',
                name: '3天投注次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 57,
                key: 'seven_bet_num',
                name: '7天投注次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 58,
                key: 'thrity_bet_num',
                name: '30天投注次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              // {
              //   num: 62,
              //   key: 'after_bet_num',
              //   name: '转入后投注次数',
              //   inp_type: '',
              //   save_type: '',
              //   unit: ''
              // },
              // {
              //   num: 106,
              //   key: 'type_unpay_bet_num',
              //   name: '未转入投注次数',
              //   inp_type: '',
              //   save_type: '',
              //   unit: ''
              // }
            ]
          },
/*          {
            title: '转入信息',
            list: [
              {
                num: 17,
                key: 'all_pay',
                name: '累计转入金额',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 46,
                key: 'today_pay',
                name: '今日转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 18,
                key: 'three_pay',
                name: '3天转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 19,
                key: 'seven_pay',
                name: '7天转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 20,
                key: 'thrity_pay',
                name: '30天转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 59,
                key: 'all_pay_num',
                name: '累计转入次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 47,
                key: 'today_pay_num',
                name: '今日转入次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 21,
                key: 'three_pay_num',
                name: '3天转入次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 22,
                key: 'seven_pay_num',
                name: '7天转入次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 23,
                key: 'thrity_pay_num',
                name: '30天转入次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 97,
                key: 'type_today_pay_avg',
                name: '今日次均转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 98,
                key: 'type_three_pay_avg',
                name: '3日次均转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 99,
                key: 'type_merge_history_avg',
                name: '合服历史转入',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              }
            ]
          },
          {
            title: '转出信息',
            list: [
              {
                num: 24,
                key: 'all_put',
                name: '累计转出',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 48,
                key: 'today_put',
                name: '今日转出',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 25,
                key: 'three_put',
                name: '3天转出',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 26,
                key: 'seven_put',
                name: '7天转出',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 27,
                key: 'thrity_put',
                name: '30天转出',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 49,
                key: 'today_put_num',
                name: '今日转出次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 28,
                key: 'three_put_num',
                name: '3天转出次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 29,
                key: 'seven_put_num',
                name: '7天转出次数',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 30,
                key: 'thrity_put_num',
                name: '30天转出次数',
                inp_type: '',
                save_type: '',
                unit: ''
              }
            ]
          },*/
          {
            title: '盈亏金额',
            list: [
              {
                num: 31,
                key: 'all_win',
                name: '累计赢钱',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 32,
                key: 'today_win',
                name: '今天赢钱',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 33,
                key: 'three_win',
                name: '3天赢钱',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 34,
                key: 'seven_win',
                name: '7天赢钱',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              {
                num: 35,
                key: 'thrity_win',
                name: '30天赢钱',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              },
              // {
              //   num: 61,
              //   key: 'after_bet_win',
              //   name: '转入后赢钱',
              //   inp_type: '',
              //   save_type: 'X10000',
              //   unit: '元'
              // },
              {
                num: 89,
                key: 'type_today_real_win',
                name: '今日实钱盈亏',
                inp_type: '',
                save_type: 'X10000',
                unit: '元'
              }
            ]
          },
          {
            title: '盈亏比例',
            list: [
              {
                num: 36,
                key: 'all_winrate',
                name: '累计盈利比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 37,
                key: 'today_winrate',
                name: '今天盈利比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 38,
                key: 'three_winrate',
                name: '3天盈利比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 39,
                key: 'seven_winrate',
                name: '7天盈利比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 40,
                key: 'thirty_winrate',
                name: '30天盈利比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              // {
              //   num: 69,
              //   key: 'after_pay_winrate',
              //   name: '转入后盈亏比例',
              //   inp_type: '',
              //   save_type: 'X100',
              //   unit: '%'
              // },
              // {
              //   num: 76,
              //   key: 'after_win_winrate',
              //   name: '转入后盈亏转入比',
              //   inp_type: '',
              //   save_type: 'X100',
              //   unit: '%'
              // },
              {
                num: 51,
                key: 'check_pool_win',
                name: '大盘盈亏率',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 52,
                key: 'check_game_win',
                name: '游戏盈亏率',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 53,
                key: 'check_game_people',
                name: '赢钱人数比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              // {
              //   num: 91,
              //   key: 'type_history_win_pay',
              //   name: '累计盈亏转入比',
              //   inp_type: '',
              //   save_type: 'X100',
              //   unit: '%'
              // },
              // {
              //   num: 92,
              //   key: 'type_three_win_pay',
              //   name: '3天盈利转入比',
              //   inp_type: '',
              //   save_type: 'X100',
              //   unit: '%'
              // }
            ]
          },
/*          {
            title: '数值比例',
            list: [
              {
                num: 70,
                key: 'day_pay_put_rate',
                name: '当天转入转出比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 71,
                key: 'three_pay_put_rate',
                name: '三天转入转出比例 ',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 72,
                key: 'seven_pay_put_rate',
                name: '七天转入转出比例',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 73,
                key: 'day_bet_pay_rate',
                name: '当天投注转入比',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 74,
                key: 'three_bet_pay_rate',
                name: '三天投注转入比',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              },
              {
                num: 75,
                key: 'seven_bet_pay_rate',
                name: '七天投注转入比',
                inp_type: '',
                save_type: 'X100',
                unit: '%'
              }
            ]
          },*/
          {
            title: '游戏时间',
            list: [
              {
                num: 64,
                key: 'day_gameTime',
                name: '当天游戏时间',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              // {
              //   num: 63,
              //   key: 'after_bet_gameTime',
              //   name: '转入后游戏时间 ',
              //   inp_type: '',
              //   save_type: '',
              //   unit: ''
              // }
            ]
          },
          {
            title: '赠送金额',
            list: [
              {
                num: 45,
                key: 'give_point',
                name: '赠送金额',
                inp_type: '',
                save_type: '',
                unit: '元'
              }
            ]
          },
          {
            title: '其他信息',
            list: [
              {
                num: 43,
                key: 'check_ip',
                name: 'IP限制',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 44,
                key: 'check_mac',
                name: 'MAC限制',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 41,
                key: 'has_pid',
                name: '是否有上级',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 42,
                key: 'has_child',
                name: '是否有下级',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 50,
                key: 'check_game',
                name: '游戏场次',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 77,
                key: 'check_phone',
                name: '手机号段',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 78,
                key: 'user_tag',
                name: '用户标签',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 87,
                key: 'pack_no',
                name: '子商户号',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 88,
                key: 'gener_no',
                name: '商户号',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 90,
                key: 'type_check_pid',
                name: '判断上级',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 82,
                key: 'type_risk_attr',
                name: '风控属性',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 104,
                key: 'type_emulator',
                name: '模拟器防刷',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 101,
                key: 'type_operator',
                name: '云服务商限制',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 107,
                key: 'type_operator_ip',
                name: '云运营商IP限制',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 108,
                key: 'type_black_phone ',
                name: '包含手机号黑名单',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 109,
                key: 'type_caijin_library',
                name: '包含彩金库用户',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 110,
                key: 'type_bind_phone',
                name: '是否绑定手机号',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 111,
                key: 'type_android_ver',
                name: '安卓版本号',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 112,
                key: 'type_reg_login_same_ip',
                name: '登录和注册ip一致',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 113,
                key: 'type_reg_login_same_mac',
                name: '登录和注册mac一致',
                inp_type: '',
                save_type: '',
                unit: ''
              },
              {
                num: 116,
                key: 'type_continue_abnormal',
                name: '异常库玩家',
                inp_type: '',
                save_type: '',
                unit: ''
              }
            ]
          }
        ],
        list_show: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        form: {
          ref: 'modal1_form',
          data: { fields: [] }
        }
      },
      modal2: {
        type: 'add',
        show: false,
        form: {
          ref: 'modal2_form',
          data: { result: {} }
        }
      },
      modal3: {
        show: false,
        form: {
          ref: 'modal3_form',
          rules: this.getAppPlatRule()
        },
        params: { platid: -1, app_id: -1, page: 1, page_size: 10 },
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            title: '所属盘口',
            key: 'app_id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              let arr = []
              let app_info = this.select.app_list.filter(
                v => v.value == params.row.app_id
              )[0]
              if (app_info) {
                arr.push(
                  h('span', app_info.name),
                  h('span', { style: 'color:#bbb' }, `（${app_info.value}）`)
                )
              } else {
                arr.push(h('span', { style: 'color:#ed4014' }, `未找到指定App`))
              }
              return h('div', arr)
            }
          },
          { title: '玩家ID', key: 'uid', minWidth: 90, align: 'center' },
          {
            title: '白名单类型',
            key: 'type',
            minWidth: 120,
            align: 'center',
            render: (h, params) =>
              h(
                'div',
                {
                  style: `color:${
                    ['#ed4014', '#19be6b', 'red'][params.row.type]
                  }`
                },
                ['不执行智能风控', '不执行IP限制', '不执行Mac限制'][
                  params.row.type
                ]
              )
          },
          {
            title: '更新时间',
            key: 'update_time',
            minWidth: 90,
            align: 'center'
          },
          {
            title: '管理',
            key: 'id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: `确认删除此条白名单记录`,
                          onOk: () => {
                            let param = this.getTransParams(
                              'UpdateGameRiskWhite',
                              {
                                platid: this.modal3.params.platid,
                                app_id: this.modal3.params.app_id,
                                id: params.row.id,
                                uid: params.row.uid
                              }
                            )
                            TransTopReq(param).then(res => {
                              this.getGameRiskWhites()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        total: 0,
        pagesizes: [10, 20, 30, 40]
      },
      modal4: {
        show: false,
        params: { id: '', uid: 0, type: 0, platid: -1, app_id: -1 },
        form: {
          data: {},
          ref: 'modal4_form',
          rules: {
            uid: [
              {
                required: true,
                trigger: 'blur',
                validator: this.simpleVerify('请输入用户ID')
              }
            ]
          }
        }
      },
      modal5: {
        show: false,
        type_list: [
          { value: 1, name: 'IP限制' },
          { value: 2, name: 'Mac限制' }
        ],
        form: {
          ref: 'modal5_form',
          rules: {
            uid: [
              {
                required: true,
                trigger: 'blur',
                validator: this.simpleVerify('请输入用户ID')
              }
            ],
            t: [
              {
                required: true,
                trigger: 'change',
                validator: this.simpleVerify('请选择类型')
              }
            ],
            ...this.getAppPlatRule()
          }
        },
        params: { platid: -1, app_id: -1, t: 0, uid: 0 },
        total: 0,
        data: ''
      },
      modal6: {
        show: false,
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          { title: 'IP地址', key: 'ip', minWidth: 90, align: 'center' },
          { title: '描述', key: 'desc', minWidth: 90, align: 'center' },
          { title: '时间', key: 'itime', minWidth: 90, align: 'center' },
          {
            title: '管理',
            key: 'id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: `确认删除此条白名单记录`,
                          onOk: () => {
                            this.updateGameRiskBlackIp(params.row.id)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        form: {
          ref: 'modal6_form',
          rules: this.getAppPlatRule()
        },
        params: { platid: -1, app_id: -1 }
      },
      modal7: {
        show: false,
        form: {
          rules: this.getAppPlatRule(),
          data: {},
          ref: 'modal4_form'
        },
        params: { id: '', ip: '', desc: '' }
      }
    }
  },
  methods: {
    getAppPlatRule() {
      return {
        app_id: [
          {
            required: true,
            trigger: 'change',
            validator: this.currentVerify('请选择所属APP')
          }
        ],
        platid: [
          {
            required: true,
            trigger: 'change',
            validator: this.currentVerify('请选择所属APP')
          }
        ]
      }
    },
    currentVerify(message) {
      return (rule, value, callback) => {
        if (value < 0 || value == undefined) {
          callback(new Error(message))
        } else {
          callback()
        }
      }
    },

    //获取标签列表
    TagList() {
      GetUserTagList({}).then(res => {
        this.select.TagList = res._param.list || []
      })
    },
    add() {
      this.modal2.form.data['risk_user_attr'].splice(
        this.modal2.form.data['risk_user_attr'].length,
        0,
        { attr: '', rate: 0 }
      )
    },
    delete_risk_user_attr(id) {
      this.modal2.form.data['risk_user_attr'].splice(id, 1)
    },
    addRet() {
      this.modal2.form.data['ret'].splice(
        this.modal2.form.data['ret'].length,
        0,
        { level: null, rate: 0 }
      )
    },
    delete_risk_ret(id) {
      this.modal2.form.data['ret'].splice(id, 1)
    },
    changeAtrNum() {
      let num = 0
      this.modal2.form.data['risk_user_attr'].map((item, index) => {
        if (index != 2) {
          num += item.rate
        }
      })
      this.modal2.form.data['risk_user_attr'][2]['rate'] = 100 - num
    },
    GetGameRoomInfoList() {
      GetGameRoomInfo({}).then(res => {
        let data = res._param.data
        let nlist = []

        data.map(item => {
          nlist.push({
            game_id: item.game_id,
            name: item.name,
            Gname: item.Gname,
            level: item.level,
            rule: item.rule
          })
        })
        this.select.room_list = nlist
      })
    },
    GetAppTagListList() {
      let param = { tag_type: 'smart_tag', page: 1, page_size: 10000 }
      GetAppTagList(param).then(res => {
        let data = res._param.List || []
        let nlist = []

        data.map(item => {
          nlist.push({
            value: item.id,
            name: item.tag_name
          })
        })
        this.select.smart_tag_list = nlist
      })
    },
    GetList() {
      let params = { ...this.table.params }
      params.ctype =
        Number(params.ctype) === params.ctype ? Number(params.ctype) : -1
      params.tag = Number(params.tag)
      GetSmartRiskList(params).then(res => {
        let data = res._param
        this.table.data = data.list || []
        this.table.page_total = data.total
      })
    },
    ChangePage(page) {
      this.table.params.page = page
      this.table.page_current = page
      this.GetList()
    },
    ChangePageSize(page_size) {
      this.table.params.page = 1
      this.table.page_current = 1
      this.table.params.page_size = page_size
      this.table['sel_ids'] = []
      this.GetList()
    },
    SelectRow(selection) {
      this.table['sel_datas'] = []
      this.table['sel_ids'] = []
      selection.map(item => {
        this.table['sel_datas'].push(item)
        this.table['sel_ids'].push(item.id)
      })
    },
    // 排序
    changeSort(data) {
      switch (data.key) {
        case 'updated_time':
          this.table.params.sort = data.order == 'desc' ? 1 : 2
          break
        case 'sorts':
          this.table.params.sort = data.order == 'desc' ? 3 : 0
          break
      }
      this.GetList()
    },
    SearList() {
      this.table.params.page = 1
      this.$refs[this.table.ref]['currentPage'] = 1
      this.table.page_current = 1
      this.GetList()
    },
    Delete(id) {
      if (id) {
        DelSmartRiskList({ ids: [id] }).then(res => {
          this.GetList()
        })
      } else {
        let data_list = this.table['sel_ids']
        let params = { ids: data_list }
        this.$Modal.confirm({
          title: '确认删除',
          content: `确认删除 <span style="color:red">${data_list.length}</span> 条记录`,
          onOk: () => {}
        })
      }
    },
    Refres() {
      let param = { is_all: 1, refresh_cfg: [3] }
      RefreshConfig(param).then(res => {
        this.$Notice.success({
          title: '操作提示',
          desc: '成功刷新配置'
        })
        this.GetList()
      })
    },
    Update() {
      let arr = [108, 109, 110]
      let fields_list = []
      this.modal1.list.map(item => {
        item.list.map(item2 => {
          fields_list.push(item2)
        })
      })

      let narr = fields_list.filter(v =>
        this.modal1.form.data.fields.includes(v.key)
      )

      let obj = {}
      narr.map(item => {
        let initItem = {
          min: 0,
          max: 0,
          t: arr.includes(Number(item.num)) ? 1 : 0
        }
        if (this.modal2.form.data['list'].length == 0) {
          obj[item.num] = initItem
        } else {
          this.modal2.form.data['list'].map(v => {
            if (item.num == v.num) {
              obj[item.num] = { min: v.min, max: v.max, t: v.t, val: v.val }
            } else {
              if (obj[item.num] == undefined) {
                obj[item.num] = initItem
              }
            }
          })
        }
      })
      let row_data = { list: obj }
      this.closeModalByIndex(1)
      this.OpenModal2('fanhui', row_data)
    },
    DeleteCelue(num) {
      this.modal2.form.data['list'].splice(num, 1)
    },
    openModalByIndex(index) {
      let modalName = `modal${index}`
      if (index == 7) {
        this.modal7.params = { id: '', ip: '', desc: '' }
      }
      if (index == 4) {
        let result = { uid: null, id: '', type: 0 }
        this.modal4.params = result
      }
      if (index == 5) {
        let result = { app_id: -1, t: 0, uid: null }
        this.modal5.params = result
        this.$refs[this.modal5.form.ref].resetFields()
      }
      this[modalName].show = true
    },
    closeModalByIndex(index) {
      let modalName = `modal${index}`
      this[modalName].show = false
      if (index == 4 || index == 7) {
        this.$refs[this[modalName].form.ref].resetFields()
      }
      if (index == 1) {
        this.$refs[this.modal2.form.ref].resetFields()
      }
    },
    // 新增 控制策略
    OpenModal1(type) {
      this.modal1.show = true
      this.modal1.type = type
    },
    // 编辑
    OpenModal2(type, row = {}) {
      //获取个人分风控buff列表
      this.modal2.show = true
      this.modal2.type = type
      let data = {}
      let rowData = this.copyData(row)
      let ret_data = []
      UserRiskBuffList({}).then(res => {
        this.select.ret_List = res['_param'].data || []
      })
      if (type == 'add') {
        data = {
          sorts: null,
          status: 1,
          ctype: this.modal2.form.data['ctype'] || 0,
          result: {
            pvp_level: 0,
            prize_rate: null,
            pve_rate: null,
            exec_rate: null
          },
          list: {},
          risk_user_attr: [
            { attr: '', rate: 0 },
            { attr: '', rate: 0 },
            { attr: 'jump', rate: 100 }
          ],
          ret: [],
          clean_buff: [{ k: 0, v: 0 }],
          ...rowData
        }
      } else if (type == 'edit') {
        data = {
          ...this.modal2.form.data,
          ...rowData,
          ret: rowData.ret || []
        }
        data.ctype = data.ctype ? data.ctype : 0
      } else if (type == 'fanhui') {
        data = {
          ...this.modal2.form.data,
          ...rowData
        }
      }
      data.status = data.status.toString()
      data.succ_max = data.succ_max != undefined ? data.succ_max.toString() : ''
      data.fish_succ_max =
        data.fish_succ_max != undefined ? data.fish_succ_max.toString() : ''
      data.result.pvp_level = data.result.pvp_level.toString()
      let fields_list = []
      this.modal1.list.forEach(item => {
        item.list.forEach(item2 => {
          fields_list.push(item2)
        })
      })
      let nlist = []
      for (var keys in data.list) {
        let item = data.list[keys]
        let info = fields_list.find(v => v.num == keys) || {}
        let { key, name, unit, save_type } = info
        if (type != 'fanhui') {
          if (save_type == 'X10000') {
            item.min /= 10000
            item.max /= 10000
          } else if (save_type == 'X100') {
            item.min /= 100
            item.max /= 100
          }
        }
        let val = item.val
        let arr = ['77', '87', '88', '90', '101', '104', '111']
        if (arr.includes(keys)) {
          val = val ? (Array.isArray(val) ? val.join(',') : val) : null
        }
        nlist.push({
          num: keys,
          key,
          name,
          unit,
          save_type,
          ...data.list[keys],
          val
        })
      }
      data.risk_user_attr =
        data.risk_user_attr != 0
          ? data.risk_user_attr
          : [
              { attr: '', rate: 0 },
              { attr: '', rate: 0 },
              { attr: 'jump', rate: 100 }
            ]
      data.clean_buff =
        data.clean_buff != 0 ? data.clean_buff : [{ k: 0, v: 0 }]
      data.list = nlist
      if (nlist.length > 0) {
        if (nlist.find(el => el.num == '78')) {
          this.TagList()
        }
      }
      this.modal2.form.data = data
    },
    updateGameRiskWhite() {
      this.$refs[this.modal4.form.ref].validate(valid => {
        if (valid) {
          let { platid, app_id } = this.modal3.params
          let params = this.getTransParams('UpdateGameRiskWhite', {
            ...this.modal4.params,
            platid,
            app_id
          })
          TransTopReq(params).then(res => {
            this.getGameRiskWhites()
            this.closeModalByIndex(4)
          })
        }
      })
    },
    getTransParams(_func, params, from) {
      let { platid, app_id } = from || params
      return {
        mod: 'root',
        platid,
        app_id,
        param: {
          _mod: 'root',
          _func,
          _param: { ...params }
        }
      }
    },
    getGameRiskWhites() {
      let params = this.getTransParams('GetGameRiskWhites', this.modal3.params)
      TransTopReq(params).then(res => {
        this.modal3.data = res._param.data || []
        this.modal3.total = res._param.total || 0
      })
    },
    //查询分条
    modal3limitchange(limit) {
      this.modal3.params.page = 1
      this.modal3.params.page_size = limit
      this.getGameRiskWhites()
    },
    //查询分页
    modal3pagechange(page) {
      this.modal3.params.page = page
      this.getGameRiskWhites()
    },

    getGameRiskBlackIps() {
      let params = this.getTransParams(
        'GetGameRiskBlackIps',
        this.modal3.params
      )
      TransTopReq(params).then(res => {
        this.modal6.data = res._param.data || []
      })
    },
    updateGameRiskBlackIp(id) {
      if (id) {
        this.modal7.params.id = id
      }
      let params = this.getTransParams(
        'UpdateGameRiskBlackIp',
        this.modal7.params,
        this.modal6.params
      )
      TransTopReq(params).then(res => {
        this.getGameRiskBlackIps()
        this.closeModalByIndex(7)
      })
    },
    Back() {
      let data = this.modal2.form.data['list']
      let arr = []
      data.map(item => {
        arr.push(item.key)
      })
      this.modal1.form.data.fields = arr
      this.closeModalByIndex(2)
      this.OpenModal1(this.modal2.type)
    },
    getSmartRiskAttrs() {
      GetSmartRiskAttrs({}).then(res => {
        let data = res._param.list || []
        this.select.attrs_list =
          data.map(item => {
            return {
              value: item,
              name: item
            }
          }) || []
      })
    },
    Update2() {
      let num = 0
      this.modal2.form.data['ret'].map((item, index) => {
        num += item.rate
      })
      if (num > 100) {
        return this.$Message.error('策略执行结果配置概率相加不能超过100%')
      }
      // if(!this.modal2.form.data.risk_user_attr[0].rate&&this.modal2.form.data.ctype==1){return this.$Message.error('触发当前属性值1-100')}
      let params = { ...this.modal2.form.data }
      params.status = Number(params.status)
      params.succ_max = Number(params.succ_max)
      params.fish_succ_max = Number(params.fish_succ_max)
      params.ctype = Number(params.ctype)
      params.result.pvp_level = Number(params.result.pvp_level)
      let obj = {}
      params.list.forEach(item => {
        let newArr = [108, 109, 110]
        if (newArr.includes(Number(item.num))) {
          obj[item.num] = {
            min: 0,
            max: parseInt(`${(item.t - 1).toFixed(0)}`),
            t: item.t,
            val: null
          }
        } else {
          let min = item.min
          let max = item.max
          if (item.save_type == 'X10000') {
            min *= 10000
            max *= 10000
          } else if (item.save_type == 'X100') {
            min *= 100
            max *= 100
          }
          let val = item.val
          let arr = ['77', '87', '88', '90', '101', '104', '111']
          if (arr.includes(item.num)) {
            //手机号段,子商户号，商户号做特殊处理,云服务商限制,模拟器防刷
            if (val) {
              val = val.toString().split(',')
            } else {
              val = []
            }
          }
          obj[item.num] = { min, max, t: item.t, val }
        }
      })
      params.list = obj
      params.risk_user_attr = params.ctype == 0 ? [] : params.risk_user_attr
      UpdateSmartRiskList(params).then(res => {
        this.closeModalByIndex(2)
        this.GetList()
        this.getSmartRiskAttrs()
      })
    },
    querySmartRiskInfo() {
      let params = this.getTransParams('QuerySmartRiskInfo', this.modal5.params)
      TransTopReq(params).then(res => {
        this.modal5.data = res._param.data || []
        this.modal5.total = res._param.total
      })
    },

    searchSmartList() {
      this.$refs[this.modal5.form.ref].validate(valid => {
        if (valid) {
          this.querySmartRiskInfo()
        }
      })
    },
    initFunc() {
      let result = []
      this.app_list.forEach(item => {
        result.push({
          value: item.appid || 0,
          name: item.appName,
          platform: item.platform
        })
      })
      this.select.app_list = result
      this.select.whiteapp_list = result.filter(item => item.value)
    }
  },

  created() {
    if (this.$route.params.id) {
      this.table.params.tag = Number(this.$route.params.id)
    }
    this.initFunc()
    this.GetGameRoomInfoList()
    this.GetAppTagListList()
    this.getSmartRiskAttrs()
    this.GetList()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.table.params.tag = Number(this.$route.params.id)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.diyItemCol {
  padding: 5px;
}
#modal2 .ivu-form-item {
  margin-bottom: 12px;
}
.mobileW {
  min-width: 620px !important;
}

.intelligentModal1 .ivu-collapse-content > .ivu-collapse-content-box {
  padding: 0;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}

/deep/ .ivu-form-item-content {
  display: flex;
}
</style>
